"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../common/constants");
var ObjectExporter = /** @class */ (function () {
    function ObjectExporter() {
    }
    ObjectExporter.prototype.export = function (item, options, inGroup) {
        if (inGroup === void 0) { inGroup = false; }
        var object;
        switch (item.type) {
            case constants_1.LayerType.STATIC_IMAGE:
                object = this.staticImage(item, options, inGroup);
                break;
            case constants_1.LayerType.BACKGROUND_IMAGE:
                object = this.backgroundImage(item, options, inGroup);
                break;
            case constants_1.LayerType.STATIC_VIDEO:
                object = this.staticVideo(item, options, inGroup);
                break;
            case constants_1.LayerType.STATIC_TEXT:
                object = this.staticText(item, options, inGroup);
                break;
            case constants_1.LayerType.STATIC_VECTOR:
                object = this.staticVector(item, options, inGroup);
                break;
            case constants_1.LayerType.STATIC_PATH:
                object = this.staticPath(item, options, inGroup);
                break;
            case constants_1.LayerType.BACKGROUND:
                object = this.background(item, options, inGroup);
                break;
            case constants_1.LayerType.GROUP.toLowerCase():
                object = this.group(item, options, inGroup);
                break;
            case constants_1.LayerType.STATIC_AUDIO:
                object = this.staticAudio(item, options, inGroup);
                break;
            default:
                object = this.background(item, options, inGroup);
        }
        return object;
    };
    ObjectExporter.prototype.staticText = function (item, options, inGroup) {
        var baseOptions = this.getBaseOptions(item, options, inGroup);
        var _a = item, fontFamily = _a.fontFamily, textAlign = _a.textAlign, fontSize = _a.fontSize, fontWeight = _a.fontWeight, fontStyle = _a.fontStyle, charSpacing = _a.charSpacing, lineHeight = _a.lineHeight, fill = _a.fill, text = _a.text, angle = _a.angle, underline = _a.underline, fontURL = _a.fontURL, metadata = _a.metadata;
        var object = __assign(__assign({}, baseOptions), { charSpacing: charSpacing, fill: fill, fontFamily: fontFamily, fontSize: fontSize, fontWeight: fontWeight, fontStyle: fontStyle, lineHeight: lineHeight, text: text, textAlign: textAlign, angle: angle, underline: underline, fontURL: fontURL, metadata: metadata });
        return object;
    };
    ObjectExporter.prototype.staticImage = function (item, options, inGroup) {
        var baseOptions = this.getBaseOptions(item, options, inGroup);
        var _a = item, src = _a.src, cropX = _a.cropX, cropY = _a.cropY, clipPath = _a.clipPath, metadata = _a.metadata;
        var object = __assign(__assign(__assign(__assign({}, baseOptions), { src: src, cropX: cropX, cropY: cropY }), (clipPath ? { clipPath: clipPath } : {})), { metadata: metadata });
        return object;
    };
    ObjectExporter.prototype.backgroundImage = function (item, options, inGroup) {
        var baseOptions = this.getBaseOptions(item, options, inGroup);
        var _a = item, src = _a.src, cropX = _a.cropX, cropY = _a.cropY, metadata = _a.metadata;
        var object = __assign(__assign({}, baseOptions), { src: src, cropX: cropX, cropY: cropY, metadata: metadata });
        return object;
    };
    ObjectExporter.prototype.staticAudio = function (item, options, inGroup) {
        var baseOptions = this.getBaseOptions(item, options, inGroup);
        var _a = item, src = _a.src, metadata = _a.metadata;
        var object = __assign(__assign({}, baseOptions), { src: src, metadata: metadata, speedFactor: 1 });
        return object;
    };
    ObjectExporter.prototype.staticVideo = function (item, options, inGroup) {
        var baseOptions = this.getBaseOptions(item, options, inGroup);
        var src = item.src;
        var object = __assign(__assign({}, baseOptions), { src: src, metadata: {}, speedFactor: 1 });
        return object;
    };
    ObjectExporter.prototype.staticVector = function (item, options, inGroup) {
        var baseOptions = this.getBaseOptions(item, options, inGroup);
        var _a = item, src = _a.src, colorMap = _a.colorMap, metadata = _a.metadata;
        var object = __assign(__assign({}, baseOptions), { src: src, colorMap: colorMap, metadata: metadata });
        return object;
    };
    ObjectExporter.prototype.staticPath = function (item, options, inGroup) {
        var baseOptions = this.getBaseOptions(item, options, inGroup);
        var _a = item, path = _a.path, fill = _a.fill, metadata = _a.metadata;
        var object = __assign(__assign({}, baseOptions), { path: path, fill: fill, metadata: metadata });
        return object;
    };
    ObjectExporter.prototype.background = function (item, options, inGroup) {
        var baseOptions = this.getBaseOptions(item, options, inGroup);
        var _a = item, fill = _a.fill, metadata = _a.metadata;
        var object = __assign(__assign({}, baseOptions), { fill: fill, metadata: metadata });
        return object;
    };
    ObjectExporter.prototype.group = function (item, options, inGroup) {
        var _this = this;
        var baseOptions = this.getBaseOptions(item, options, inGroup);
        var _a = item, objects = _a.objects, metadata = _a.metadata;
        var groupObjects = objects.map(function (object) {
            return _this.export(object, options, true);
        });
        return __assign(__assign({}, baseOptions), { type: "Group", objects: groupObjects, metadata: metadata });
    };
    ObjectExporter.prototype.getBaseOptions = function (item, options, inGroup) {
        if (inGroup === void 0) { inGroup = false; }
        var _a = item, id = _a.id, name = _a.name, top = _a.top, left = _a.left, width = _a.width, height = _a.height, scaleX = _a.scaleX, scaleY = _a.scaleY, originX = _a.originX, originY = _a.originY, type = _a.type, stroke = _a.stroke, strokeWidth = _a.strokeWidth, opacity = _a.opacity, angle = _a.angle, flipX = _a.flipX, flipY = _a.flipY, skewX = _a.skewX, skewY = _a.skewY, shadow = _a.shadow, preview = _a.preview;
        var baseOptions = {
            id: id,
            name: name ? name : type,
            angle: angle,
            stroke: stroke,
            strokeWidth: strokeWidth,
            left: inGroup ? left : left - options.left,
            top: inGroup ? top : top - options.top,
            width: width,
            height: height,
            opacity: opacity,
            originX: originX,
            originY: originY,
            scaleX: scaleX,
            scaleY: scaleY,
            type: type,
            flipX: flipX,
            flipY: flipY,
            skewX: skewX,
            skewY: skewY,
            visible: true,
            shadow: shadow,
            preview: preview,
        };
        return baseOptions;
    };
    return ObjectExporter;
}());
exports.default = ObjectExporter;
//# sourceMappingURL=object-exporter.js.map